// extracted by mini-css-extract-plugin
module.exports = {"root":"ysb3g","link":"_2u3z_"};